import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import DashboardPage from './pages/DashboardPage';
import StockAvgCalculator from './pages/StockAvgCalculator';
import ProfitCalculator from './pages/ProfitCalculator';
import EditorPage from './pages/EditorPage';
import ApkBuilderPage from './pages/ApkBuilderPage';
import ConverterPage from './pages/ConverterPage';
import ArchitecturePage from './pages/ArchitecturePage';
import AssetsPage from './pages/AssetsPage';
import DeployPage from './pages/DeployPage';
import NotFoundPage from './pages/NotFoundPage';

const App: React.FC = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/stock-avg" element={<StockAvgCalculator />} />
        <Route path="/profit-calc" element={<ProfitCalculator />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/apk" element={<ApkBuilderPage />} />
        <Route path="/converter" element={<ConverterPage />} />
        <Route path="/architecture" element={<ArchitecturePage />} />
        <Route path="/assets" element={<AssetsPage />} />
        <Route path="/deploy" element={<DeployPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
};

export default App;
